// extracted by mini-css-extract-plugin
module.exports = {"priceBox":"PriceBox_priceBox__2omwh","label":"PriceBox_label__1NGue","price":"PriceBox_price__1Ozqm"};